import { useGetFeatureValue } from 'utils/useHasFeature'
import { GlobalPricingGoal } from '../../products/pricing/pricingService'
import { t } from 'translations'

export interface PricingModelOption {
    value: GlobalPricingGoal
    name: string
    description?: string
}

export const getPricingModelOptions = (): PricingModelOption[] => [
    { value: 'opt_revenue', name: t('globalPricingSettings.studio.pricingModels.optRevenue') },
    { value: 'opt_max_sold', name: t('globalPricingSettings.studio.pricingModels.optMaxSold') },
    { value: 'opt_visitor_dist', name: t('globalPricingSettings.studio.pricingModels.optVisitorDist') },
    { value: 'opt_rule_based', name: t('globalPricingSettings.studio.pricingModels.optRuleBased') },
    { value: 'early_bird_by_inventory', name: t('globalPricingSettings.studio.pricingModels.earlyBirdByInventory') },
    { value: 'early_bird_by_time', name: t('globalPricingSettings.studio.pricingModels.earlyBirdByTime') },
]

export const useGetPricingModels = (): PricingModelOption[] => {
    const pricingModelOptionsFromComponent = useGetFeatureValue('gpsModelsList')

    return pricingModelOptionsFromComponent || getPricingModelOptions()
}
